import { User } from '../core/user';
import { Recipient } from '@galaxy/partner-center-client/billing/static/core/recipients';

export interface InvoiceRecipients {
  invoiceRecipient: Recipient;
  additionalRecipients: Recipient[];
}

export function convertUserToRecipient(user: User): Recipient {
  if (!user) {
    return undefined;
  }

  return {
    id: user.userId,
    userID: user.unifiedUserId,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
  };
}

export function convertRecipientToUser(recipient: Recipient): User {
  if (!recipient) {
    return undefined;
  }

  return <User>{
    userId: recipient.id,
    unifiedUserId: recipient.userID,
    email: recipient.email,
    firstName: recipient.firstName,
    lastName: recipient.lastName,
  };
}

export function getRecipientFullName(recipient: Recipient): string {
  const fullName = `${recipient.firstName || ''} ${recipient.lastName || ''}`;
  return fullName.trim();
}
